import React, { Component } from 'react';
import { PrimaryButton } from '../../components/BasicForm';
import { PrimaryFormNav } from '../../components/PrimaryFormNav';
import { relationships } from '../../utils/relationshipList';

class SelectedOffenders extends Component {
	state = {
		heading: "Inmate(s) You've Chosen to Visit",
		showProgressBar: true,
		pageId: 'selection-review',
		nonImmediateFamily: 0,
	}
	componentWillMount() {
		const stepData = this.props.stepData;
		if(!stepData.access) {
			this.props.previousStep(stepData);
		}
		this.props.setHeaderDisplay(
			this.state.heading,
      		stepData.displayStep,
			this.state.showProgressBar,
			this.state.pageId,
      		stepData.step
		);
	}
	componentDidMount() {
		document.getElementById('root').scrollIntoView();
		window.scrollBy(0, -10);
	}
	handleRemoveOffender = (offenderId) => {
		const selectedOffenders = this.props.fields.selectedOffenders;
		let affirmative = window.confirm("Are you sure you want to remove the selected inmate?");
		if(affirmative) {
			this.props.removeSelectedOffender(offenderId)
		}
		if(Object.keys(selectedOffenders).length < 1) {
			this.handlePrevious();
		} else {
			this.countNonImmediateFam();
		}
	}
	countNonImmediateFam() {
		const selectedOffenders = this.props.fields.selectedOffenders;
		let nonImmediateFamily = 0;
		Object.keys(selectedOffenders).map(offenderId => {
			const offender = selectedOffenders[offenderId];
			if(!offender.RelationshipToVisitor.immediateFamily) {
				nonImmediateFamily += 1;
			}
			return offender;
		})
		return nonImmediateFamily;
	}
	handleEditRelationship = () => {
		this.props.history.push('/visitor-offender-relationship')
	}
	handlePrevious = () => {
		const stepData = this.props.stepData;
		this.props.previousStep(stepData);
	}
	handleSubmit = () => {
		const stepData = this.props.stepData;
		this.props.nextStep(stepData);
	}
	render() {
		const fields = this.props.fields;
		const selectedOffenders = fields.selectedOffenders;
		
		return(
			<div className="col-15">
				<p className="description">The list below shows the inmate(s) you have selected to visit.</p>
				<ul className="visitation-result-cards">
					{Object.keys(selectedOffenders).map(id => (
						<li key={id} className="result-data">
							<dl className="general-info">
								<dt>name</dt>
								<dd className="body-bold">{selectedOffenders[id].FullName}&nbsp;&#47;&#47;&nbsp;</dd>
								<dt>age</dt>
								<dd className="body-bold">{selectedOffenders[id].Age},&nbsp;</dd>
								<dt>race</dt>
								<dd className="body-bold">{selectedOffenders[id].Race},&nbsp;</dd>
								<dt>sex</dt>
								<dd className="body-bold">{selectedOffenders[id].Gender}</dd>
							</dl>
							<dl className="secondary-info">
								<div>
									<dt>Alias:&nbsp;</dt>
									<dd>{selectedOffenders[id].Alias}</dd>
								</div>
								<div>
									<dt>Inmate ID #:&nbsp;</dt>
									<dd>{selectedOffenders[id].OffenderId}</dd>
								</div>
								<div>
									<dt>Location:&nbsp;</dt>
									<dd>{selectedOffenders[id].LocationName}</dd>
								</div>
								<div>
									<dt>Release Date:&nbsp;</dt>
									<dd>{selectedOffenders[id].ProjectedReleaseDate}</dd>
								</div>
								<div>
									<dt>Relationship to Visitor:&nbsp;</dt>
									<dd>{relationships[selectedOffenders[id].RelationshipToVisitor.value]}</dd>
									<dd className="edit-info">
										<PrimaryButton 
											label="Edit" 
											className="link-style"
											handleClick={this.handleEditRelationship} />
									</dd>
								</div>
							</dl>
							<form 
								className="selection-review-delete"
								onSubmit={(e) => {this.handleRemoveOffender}}>	
								<PrimaryButton 
									className="punchout-button"
									label="Remove"
									handleClick={this.handleRemoveOffender}  
									options={id} />
							</form>
						</li>
					))}
				</ul>
				<PrimaryButton 
					label="Add another inmate"
					className="link-style"
					handleClick={this.handlePrevious} 
					id="add-offender" />
				<PrimaryFormNav 
					prevLabel="Step 3"
					nextLabel="Step 5"
					handlePrevious={this.handlePrevious}
					handleNext={this.handleSubmit} />
			</div>
		)
	}
}

export default SelectedOffenders;


// WEBPACK FOOTER //
// ./src/pages/SelectedOffenders/SelectedOffenders.js